import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'ホーム', path: '/' },
    { name: 'ビジョン', path: '/vision' },
    { name: '廃校活用プロジェクト', path: '/project' },
    { name: '陸上養殖技術', path: '/technology' },
    { name: '地域社会への貢献', path: '/community' },
    { name: 'サステナビリティ', path: '/sustainability' },
    { name: '会社概要', path: '/会社概要' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative flex items-center justify-center h-32 lg:h-[150px] lg:justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://storage.readdy-site.link/project_files/fc18929a-f6b4-4a9e-92ee-da32c9ea052d/4fe99e4d-15c2-4d8e-866a-3f5c5aac6b65_C8209D2BDE10963017F26F59233783C418DCE6A2.png?v=985436ac8d52cc034e4e004462d1a98f"
              alt="C.GREEN 株式会社シーグリーン"
              className="h-28 lg:h-[140px] w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-emerald-600'
                    : isScrolled
                    ? 'text-gray-700 hover:text-emerald-600'
                    : 'text-gray-900 hover:text-emerald-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden absolute right-0 w-10 h-10 flex items-center justify-center text-gray-900 cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-emerald-600'
                    : 'text-gray-700 hover:text-emerald-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}